import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import _ from "lodash";

import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Divider,
  Hidden,
  IconButton,
  Fab,
  Box,
} from "@material-ui/core";
import { Typography, TextField, Button } from "@packages/ui";

import SnackBar from "../../layouts/SnackBar";
import { makeStyles } from "@material-ui/core/styles";

import * as checkinActions from "src/actions/checkinActions";

import { ThemeProvider } from "react-jss";
import moment from "moment";

import { theme } from "../../components/ui/theme";

import getBrandFromUrl from "../../utils/getBrandFromUrl";
import CloseIcon from "@material-ui/icons/Close";
import * as constants from "../../utils/constants";
import { apiURI } from "../../env";
import { enableInternationalOcrFlow } from "../../env";
import getCountryFromURL from "src/utils/getCountryFromUrl";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: "150px",
  },
}));

const CheckinSteps = () => {
  const dispatch = useDispatch();
  const checkin = useSelector((state) => state.checkin);
  const isDemo = useSelector((state) => state.checkin.isDemo);
  const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
  const isHCCWorkflow = useSelector((state) => state.checkin.resType === "HX");
  const isForeignLicence = useSelector((state) => state.checkin.licCountry != "AUSTRALIA" && state.checkin.licCountry != "NEW ZEALAND");
  const idVerificationSkipped = useSelector((state) => state.checkin.idVerificationSkipped);
  const navigate = useNavigate();
  const classes = useStyles();
  const brand = getBrandFromUrl();
  let icon_Url_Step1;
  let icon_Url_Step2;
  let icon_Url_Step3;
  let icon_Url_Step4;

  const [willExpire, setWillExpire] = React.useState(false);
  const [letSessionExpire, setLetSessionExpire] = React.useState(false);
  const [sessionTracker, setSessionTracker] = React.useState(null);
  const [stepOneInfo, setStepOneInfo] = React.useState(
    "Ensure you have your driver's licence and credit card handy."
  );

  const reservationNumber = React.useMemo(() => {
    return checkin.resNo;
  }, [checkin.resNo]);

  const randomNumber = React.useMemo(() => {
    return Math.random();
  }, [checkin.resNo]);

  React.useEffect(() => {
    setLetSessionExpire(false);
    setWillExpire(false);

    const intervalId = setInterval(() => {
      const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());

      if (moment().isAfter(moment.unix(sessionExpiry))) {
        window.location.replace(`/${isDemo ? "checkin-demo" : "checkin"}/login`);
      }

      const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
      setWillExpire(isExpiring);
    }, 10000);

    setSessionTracker(intervalId);

    return () => {
      clearInterval(intervalId); // ✅ Clean up interval on unmount
    };
  }, [checkin.auth.expires]);

  // React.useEffect(() => {
  //   setLetSessionExpire(false);
  //   clearInterval(sessionTracker);
  //   setSessionTracker(
  //     setInterval(() => {
  //       const sessionExpiry = _.get(checkin, "auth.expires", moment().subtract(0, "m").unix());
  //       if (moment().isAfter(moment.unix(sessionExpiry))) {
  //         window.location.replace(`/${isDemo ? "checkin-demo" : "checkin"}/login`);
  //       }
  //       const isExpiring = moment().add(2, "m").isAfter(moment.unix(sessionExpiry));
  //       setWillExpire(isExpiring);
  //     }, 10000)
  //   );
  //   setWillExpire(false);
  // }, [checkin.auth.expires]);

  React.useEffect(() => {
    let info = "Ensure you have your passport and credit card handy.";

    if (idVerificationSkipped) {
      info = "Ensure you have your credit card handy.";
    } else if (isForeignLicence) {
      if (isAdditionalDriver || isHCCWorkflow) {
        info = "Ensure you have your passport, foreign driver's licence handy.";
      } else {
        info = "Ensure you have your passport, foreign driver's licence and credit card handy.";
      }
    } else {
      if (isAdditionalDriver || isHCCWorkflow) {
        info = "Ensure you have your driver's licence handy.";
      } else {
        info = "Ensure you have your driver's licence and credit card handy.";
      }
    }
    setStepOneInfo(info);
  }, [idVerificationSkipped, isForeignLicence, isAdditionalDriver, isHCCWorkflow]);
  const onExtendSession = () => {
    dispatch(checkinActions.extendSession());
  };

  const onClickHandler = () => {
    navigate(
      `/${
        isDemo ? "checkin-demo" : isAdditionalDriver ? "additional-driver-checkin" : "checkin"
      }/verify`
    );
  };

  switch (brand) {
    case "Ace":
      icon_Url_Step1 = constants.ACE_STEPS_ICON_1;
      icon_Url_Step2 = constants.ACE_STEPS_ICON_2;
      icon_Url_Step3 = constants.ACE_STEPS_ICON_3;
      icon_Url_Step4 = constants.ACE_STEPS_ICON_4;
      break;
    case "Dollar":
      icon_Url_Step1 = constants.DOLLAR_STEPS_ICON_1;
      icon_Url_Step2 = constants.DOLLAR_STEPS_ICON_2;
      icon_Url_Step3 = constants.DOLLAR_STEPS_ICON_3;
      icon_Url_Step4 = constants.DOLLAR_STEPS_ICON_4;
      break;
    case "Thrifty":
      icon_Url_Step1 = constants.THRIFTY_STEPS_ICON_1;
      icon_Url_Step2 = constants.THRIFTY_STEPS_ICON_2;
      icon_Url_Step3 = constants.THRIFTY_STEPS_ICON_3;
      icon_Url_Step4 = constants.THRIFTY_STEPS_ICON_4;
      break;
    default:
      icon_Url_Step1 = constants.HERTZ_STEPS_ICON_1;
      icon_Url_Step2 = constants.HERTZ_STEPS_ICON_2;
      icon_Url_Step3 = constants.HERTZ_STEPS_ICON_3;
      icon_Url_Step4 = constants.HERTZ_STEPS_ICON_4;
      break;
  }

  return (
    <div>
      <SnackBar />
      <ThemeProvider theme={theme}>
        <Hidden lgUp>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            style={{ marginTop: 20 }}
          >
            {!enableInternationalOcrFlow && isForeignLicence ? (
              <Grid container direction="column" justify="center" alignItems="center">
                <Grid item style={{ margingTop: 10 }}>
                  <Typography variant={"h4"}>Next Step</Typography>
                </Grid>
                <Grid item>
                  <img className={classes.icon} src={icon_Url_Step2} />
                </Grid>
                <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                  <Typography variant={"h5"}>Verify your credit card details</Typography>
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid item>
                  <Typography variant={"h4"}>Step 1</Typography>
                </Grid>
                <Grid item>
                  <img className={classes.icon} src={icon_Url_Step1} />
                </Grid>
                <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                  <Typography variant={"h5"}>{stepOneInfo}</Typography>
                </Grid>
                {!(isAdditionalDriver || isHCCWorkflow) && (
                  <Grid container direction="column" justify="center" alignItems="center">
                    <Grid item style={{ margingTop: 10 }}>
                      <Typography variant={"h4"}>Step 2</Typography>
                    </Grid>
                    <Grid item>
                      <img className={classes.icon} src={icon_Url_Step2} />
                    </Grid>
                    <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                      <Typography variant={"h5"}>Verify your credit card details</Typography>
                    </Grid>
                  </Grid>
                )}

                {!idVerificationSkipped && (
                  <>
                    <Grid item style={{ margingTop: 10 }}>
                      <Typography variant={"h4"}>
                        {isAdditionalDriver || isHCCWorkflow ? "Step 2" : "Step 3"}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <img className={classes.icon} src={icon_Url_Step3} />
                    </Grid>
                    <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                      <Typography variant={"h5"}>
                        Submit a photo of your {isForeignLicence && "passport and foreign"}{" "}
                        driver&apos;s licence to verify
                      </Typography>
                    </Grid>

                    <Grid item style={{ margingTop: 10 }}>
                      <Typography variant={"h4"}>
                        {isAdditionalDriver || isHCCWorkflow ? "Step 3" : "Step 4"}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <img className={classes.icon} src={icon_Url_Step4} />
                    </Grid>
                    <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                      <Typography variant={"h5"}>
                        Take a short video selfie to verify your identity
                      </Typography>
                    </Grid>
                  </>
                )}
              </>
            )}
            <Grid item xs={12} md={6} style={{ marginBottom: 15, marginTop: 10 }}>
              <Button
                fullWidth
                loading={checkin.loading}
                title={<strong>Continue</strong>}
                type="submit"
                onClick={onClickHandler}
              />
            </Grid>
          </Grid>
        </Hidden>
        <Hidden mdDown>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            style={{ marginTop: 20 }}
          >
            <Grid item>
              <Typography variant={"h4"}>Step 1</Typography>
            </Grid>
            <Grid item>
              <img className={classes.icon} src={icon_Url_Step1} />
            </Grid>
            <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
              <Typography variant={"h5"}>{stepOneInfo}</Typography>
            </Grid>
            {!(isAdditionalDriver || isHCCWorkflow) && (
              <Grid container direction="column" justify="center" alignItems="center">
                <Grid item style={{ margingTop: 10 }}>
                  <Typography variant={"h4"}>Step 2</Typography>
                </Grid>
                <Grid item>
                  <img className={classes.icon} src={icon_Url_Step2} />
                </Grid>
                <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                  <Typography variant={"h5"}>Verify your credit card details</Typography>
                </Grid>
              </Grid>
            )}

            {!idVerificationSkipped && (
              <>
                <Grid item style={{ margingTop: 10 }}>
                  <Typography variant={"h4"}>
                    {isAdditionalDriver || isHCCWorkflow ? "Step 2" : "Step 3"}
                  </Typography>
                </Grid>
                <Grid item>
                  <img className={classes.icon} src={icon_Url_Step3} />
                </Grid>
                <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                  <Typography variant={"h5"}>
                    Submit a photo of your driver&apos; license to verify
                  </Typography>
                </Grid>

                <Grid item style={{ margingTop: 10 }}>
                  <Typography variant={"h4"}>
                    {isAdditionalDriver || isHCCWorkflow ? "Step 3" : "Step 4"}
                  </Typography>
                </Grid>
                <Grid item>
                  <img className={classes.icon} src={icon_Url_Step4} />
                </Grid>
                <Grid item style={{ textAlign: "center", marginBottom: 15 }}>
                  <Typography variant={"h5"}>
                    Take a shot video selfie to verify your identity
                  </Typography>
                </Grid>
              </>
            )}

            <Grid item xs={12} style={{ marginBottom: 15, marginTop: 10 }}>
              <Button
                fullWidth
                loading={checkin.loading}
                title={<strong>Continue</strong>}
                type="submit"
                onClick={onClickHandler}
              />
            </Grid>
          </Grid>
        </Hidden>
      </ThemeProvider>

      <Dialog open={willExpire && !letSessionExpire}>
        <DialogTitle style={{ textAlign: "center" }}>
          <IconButton aria-label="close" onClick={() => setLetSessionExpire(true)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>Your session will expire in 1 minute.</DialogContent>
        <DialogActions>
          <Divider />
          <Grid spacing={1} container direction="row" justify="center">
            <Grid container item xs={12} justify="center">
              <Fab color="primary" variant="extended" onClick={onExtendSession}>
                Extend My Session
              </Fab>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      {reservationNumber != "" && (
        <img
          src={`${apiURI}/pixel/${window.location.pathname.replace(
            /\//g,
            "_"
          )}.png?b=${reservationNumber}&a=${"steps"}&country=${getCountryFromURL()}&c=${randomNumber}&brand=${brand}&t=${
            isAdditionalDriver ? "additional_driver" : "primary_driver"
          }`}
          style={{ display: "none" }}
        />
      )}
    </div>
  );
};

export default CheckinSteps;
